"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DIMENTION_ERROR_MESSAGE = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactImageCrop = _interopRequireDefault(require("react-image-crop"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _constants = require("../../libs/constants");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _FakeFileUploader = _interopRequireDefault(require("../ui-components/FakeFileUploader"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DIMENTION_ERROR_MESSAGE = "You can\u2019t upload images with more than ".concat(_constants.maxImageDimension, " pixels in width and height. Please try again with a smaller image.");
exports.DIMENTION_ERROR_MESSAGE = DIMENTION_ERROR_MESSAGE;

var ImageUploader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImageUploader, _Component);

  var _super = _createSuper(ImageUploader);

  function ImageUploader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageUploader);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploader", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "csrf", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      src: null,
      crop: {
        x: 0,
        y: 0,
        height: 100
      },
      pixelCrop: null,
      errorMessage: null,
      uploading: false
    });
    var element = document.getElementById('csrftoken');

    if (element) {
      // @ts-expect-error
      _this.csrf = element.value;
    }

    _this.saveImage = _this.saveImage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ImageUploader, [{
    key: "onSelectFile",
    value: function onSelectFile(event) {
      var _this2 = this;

      var reader = new FileReader();

      if (event.target === null) {
        return;
      }

      var _ref = event.target,
          files = _ref.files;

      if (files === null || files === undefined || files.length === 0) {
        return;
      }

      var _files = (0, _slicedToArray2.default)(files, 1),
          firstFile = _files[0];

      if (!_constants.supportedMimeTypes.includes(firstFile.type)) {
        this.setState({
          errorMessage: 'Sorry, this file type is not supported.'
        });
        return;
      }

      if (firstFile.size > _constants.maxImageFileSize) {
        this.setState({
          errorMessage: 'Sorry, the file size is too large'
        });
        return;
      }

      reader.addEventListener('load', function () {
        var uploadedImage = new Image();

        uploadedImage.onload = function () {
          if (uploadedImage.width > _constants.maxImageDimension || uploadedImage.height > _constants.maxImageDimension) {
            _this2.setState({
              errorMessage: DIMENTION_ERROR_MESSAGE
            });

            return;
          }

          _this2.setState({
            src: reader.result,
            errorMessage: null
          });
        };

        if (typeof reader.result === 'string') {
          uploadedImage.src = reader.result;
        }
      });
      reader.readAsDataURL(firstFile);
    }
  }, {
    key: "saveImage",
    value: function saveImage() {
      var _this$uploader,
          _this$uploader$files,
          _this3 = this;

      this.setState({
        uploading: true
      });
      var formData = new FormData();
      var file = (_this$uploader = this.uploader) === null || _this$uploader === void 0 ? void 0 : (_this$uploader$files = _this$uploader.files) === null || _this$uploader$files === void 0 ? void 0 : _this$uploader$files[0];

      if (file) {
        formData.append('image', file);
      }

      if (typeof this.csrf === 'string') {
        formData.append('yip_csrf_token', this.csrf);
      }

      var pixelCrop = this.state.pixelCrop;

      var hasValidCrop = function hasValidCrop(crop) {
        return crop !== null && crop.width > 0 && crop.height > 0;
      };

      if (hasValidCrop(pixelCrop)) {
        formData.append('crop_coords[x]', String(Math.round(pixelCrop.x)));
        formData.append('crop_coords[y]', String(Math.round(pixelCrop.y)));
        formData.append('crop_coords[width]', String(Math.round(pixelCrop.width)));
        formData.append('crop_coords[height]', String(Math.round(pixelCrop.height)));
      }

      var xhr = new XMLHttpRequest();
      xhr.addEventListener('readystatechange', function (event) {
        if (event.target === null) {
          return;
        }

        var xhrEvent = event.target;

        if (xhrEvent.readyState === 4 && xhrEvent.status === 200 && xhrEvent.responseText) {
          if (_this3.uploader !== null) {
            _this3.uploader.value = '';
          }

          var response = JSON.parse(xhrEvent.responseText);

          if (!hasValidCrop(pixelCrop)) {
            response.source_thumb = response.source;
          }

          _this3.props.onUploaded(response);

          _this3.setState({
            src: null,
            uploading: false
          });
        }
      }, false);
      xhr.open('POST', '/attachment/new', true);
      xhr.send(formData);
    }
  }, {
    key: "aspect",
    get: function get() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height;

      if (width !== undefined && height !== undefined) {
        return width / height;
      }

      return undefined;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      this.setState(function (prevState) {
        return {
          crop: _objectSpread(_objectSpread({}, prevState.crop), {}, {
            aspect: _this4.aspect
          })
        };
      });
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      this.setState({
        src: null
      });

      if (this.uploader !== null) {
        this.uploader.value = '';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var props = this.props,
          state = this.state;
      var isForum = (0, _insidedDataStorage.getInsidedData)('communityId');
      return (0, _preact.h)("div", {
        className: "image-cropper_uploader"
      }, state.errorMessage && (0, _preact.h)("div", {
        className: "validation-error"
      }, state.errorMessage), (0, _preact.h)(_FakeFileUploader.default, null, (0, _preact.h)("input", {
        type: "file",
        hidden: true,
        ref: function (_ref2) {
          function ref(_x) {
            return _ref2.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref2.toString();
          };

          return ref;
        }(function (ref) {
          _this5.uploader = ref;
          props.uploaderRef(ref);
        }),
        onChange: function onChange(event) {
          return _this5.onSelectFile(event);
        },
        accept: _constants.supportedMimeTypes.join(', ')
      })), (0, _preact.h)(_reactModal.default, {
        className: "image-cropper_modal",
        isOpen: Boolean(state.src),
        onClose: function onClose() {
          return _this5.cancelUpload();
        },
        asPortal: true
      }, (0, _preact.h)("div", {
        className: "image-cropper_title"
      }, "Crop Image"), (0, _preact.h)("div", {
        className: "image-cropper"
      }, (0, _preact.h)(_reactImageCrop.default // @ts-expect-error
      , {
        src: (0, _absoluteUrlRuntime.resolveUrl)(state.src),
        crop: state.crop,
        onChange: function onChange(crop, pixelCrop) {
          return _this5.setState({
            crop: crop,
            pixelCrop: pixelCrop
          });
        }
      })), (0, _preact.h)("div", {
        className: "image-cropper_footer"
      }, (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('btn--insided-secondary-brand', {
          btn: !isForum,
          'btn-default': !isForum,
          'button-control--secondary': !isForum
        }),
        type: "button",
        onClick: function onClick() {
          var _this5$uploader;

          return (_this5$uploader = _this5.uploader) === null || _this5$uploader === void 0 ? void 0 : _this5$uploader.click();
        }
      }, "Choose a new image"), (0, _preact.h)("div", {
        className: "image-cropper_footer-buttons-group"
      }, (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('btn--insided-secondary-brand', {
          btn: !isForum,
          'btn-default': !isForum,
          'button-control--secondary': !isForum
        }),
        type: "button",
        onClick: function onClick() {
          return _this5.cancelUpload();
        }
      }, "Cancel"), (0, _preact.h)(_Button.default, {
        className: (0, _classnames.default)('btn--insided-brand', {
          btn: !isForum,
          'btn-primary': !isForum
        }),
        variant: "primary",
        isLoading: state.uploading,
        type: "button",
        onClick: function onClick() {
          return _this5.saveImage();
        }
      }, "Save")))));
    }
  }]);
  return ImageUploader;
}(_preact.Component);

var _default = ImageUploader;
exports.default = _default;